export const GIFT_GET_DETAILS = 'GIFT_GET_DETAILS'
export const GIFT_SET_DETAILS = 'GIFT_SET_DETAILS'
export const GIFT_SET_DETAILS_PERSISTENT = 'GIFT_SET_DETAILS_PERSISTENT'
export const GIFT_CLEAR_DETAILS = 'GIFT_CLEAR_DETAILS'
export const GIFT_SET_PLAN_SKU = 'GIFT_SET_PLAN_SKU'
export const GIFT_CREATE_ORDER = 'GIFT_CREATE_ORDER'
export const GIFT_SET_ORDER_PROCESSING = 'GIFT_SET_ORDER_PROCESSING'
export const GIFT_SET_ORDER_DATA = 'GIFT_SET_ORDER_DATA'
export const GIFT_SET_ORDER_ERROR_DATA = 'GIFT_SET_ORDER_ERROR_DATA'
export const GIFT_UNMOUNT = 'GIFT_UNMOUNT'
export const GIFT_REDEEM = 'GIFT_REDEEM'
export const GIFT_SET_REDEEM_DATA = 'GIFT_SET_REDEEM_DATA'
export const GIFT_SET_REDEEM_ERROR_DATA = 'GIFT_SET_REDEEM_ERROR_DATA'
export const GIFT_SET_REDEEM_PROCESSING = 'GIFT_SET_REDEEM_PROCESSING'
export const GIFT_CLEAR_REDEEM_ERROR_DATA = 'GIFT_CLEAR_REDEEM_ERROR_DATA'
export const GIFT_CLEAR_ORDER_ERROR = 'GIFT_CLEAR_ORDER_ERROR'
export const GIFT_CLEAR_RECIPIENT_EMAIL_INFO = 'GIFT_CLEAR_RECIPIENT_EMAIL_INFO'

/**
 *
 * @typedef {Object} GiftDetails
 * @param {String} GiftDetails.gifterEmail
 * @param {String} GiftDetails.gifterName
 * @param {String} GiftDetails.message
 * @param {String} GiftDetails.recipientFirstName
 * @param {String} GiftDetails.recipientLastName
 * @param {String} GiftDetails.recipientUuid
 * @param {Date} GiftDetails.redeemedAt
 * @param {Date} GiftDetails.deliveryDate
 * @param {Date} GiftDetails.deliveredAt
 * @param {String} GiftDetails.token
 * @param {String} GiftDetails.planName
 * @param {String} GiftDetails.planId
 * @param {String} GiftDetails.message
 * @param {Number} GiftDetails.statusCode
 *
 * @typedef {Object} SetGiftDetailsAction
 * @property {String} SetGiftDetailsAction.type
 * @property {GiftDetails} SetGiftDetailsAction.payload
 *
 * @param {GiftDetails} details
 * @returns {SetGiftDetailsAction}
 *
 */
export function setGiftDetails (details) {
  return {
    type: GIFT_SET_DETAILS,
    payload: details,
  }
}

/**
 *
 * @typedef {Object} GiftDetails
 * @param {String} GiftDetails.gifterEmail
 * @param {String} GiftDetails.gifterName
 * @param {String} GiftDetails.message
 * @param {String} GiftDetails.recipientFirstName
 * @param {String} GiftDetails.recipientLastName
 * @param {String} GiftDetails.recipientUuid
 * @param {Date} GiftDetails.redeemedAt
 * @param {Date} GiftDetails.deliveryDate
 * @param {Date} GiftDetails.deliveredAt
 * @param {String} GiftDetails.token
 * @param {String} GiftDetails.planName
 * @param {String} GiftDetails.planId
 * @param {String} GiftDetails.message
 * @param {Number} GiftDetails.statusCode
 *
 * @typedef {Object} SetGiftDetailsAction
 * @property {String} SetGiftDetailsAction.type
 * @property {GiftDetails} SetGiftDetailsAction.payload
 *
 * @param {GiftDetails} details
 * @returns {SetGiftDetailsAction}
 *
 */
export function setGiftDetailsPersistent (details) {
  return {
    type: GIFT_SET_DETAILS_PERSISTENT,
    payload: details,
  }
}

/**
 *
 * @typedef {Object} GetGiftDetailsPayload
 * @param {String} GiftDetails.token
 *
 * @typedef {Object} GetGiftDetailsAction
 * @property {String} SetGiftDetailsAction.type
 * @property {GetGiftDetailsPayload} SetGiftDetailsAction.payload
 *
 * @param {String} token
 * @returns {GetGiftDetailsAction}
 *
 */
export function getGiftDetails (token) {
  return {
    type: GIFT_GET_DETAILS,
    payload: { token },
  }
}

export function createGiftOrder (value) {
  return {
    type: GIFT_CREATE_ORDER,
    payload: { value },
  }
}

export function clearRecipientEmailInfo () {
  return {
    type: GIFT_CLEAR_RECIPIENT_EMAIL_INFO,
  }
}

/**
 * @typedef {Object} SetGiftPlanSKUAction
 * @property {String} SetGiftPlanSKUAction.type
 * @property {String} SetGiftPlanSKUAction.payload
 *
 * @param {String} sku
 * @returns {SetGiftPlanSKUAction}
 *
 */
export function setGiftPlanSKU (sku) {
  return {
    type: GIFT_SET_PLAN_SKU,
    payload: sku,
  }
}

export function giftRedeem (user) {
  return {
    type: GIFT_REDEEM,
    payload: user,
  }
}

export function clearGiftOrderError () {
  return {
    type: GIFT_CLEAR_ORDER_ERROR,
  }
}
